import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Lenspire_Icon_CloseButton",
  "use": "Lenspire_Icon_CloseButton-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol viewBox=\"0 0 10 10\" id=\"Lenspire_Icon_CloseButton\">\n<path d=\"M6.178,5l3.579-3.578c0.324-0.325,0.324-0.853,0-1.178c-0.325-0.326-0.854-0.326-1.18,0L5,3.822L1.423,0.244\n\tc-0.326-0.326-0.854-0.326-1.179,0c-0.325,0.326-0.325,0.853,0,1.178L3.821,5L0.244,8.578c-0.325,0.325-0.325,0.853,0,1.178\n\tC0.406,9.919,0.62,10,0.833,10c0.213,0,0.427-0.081,0.59-0.244L5,6.178l3.577,3.578C8.739,9.919,8.953,10,9.167,10\n\ts0.426-0.081,0.59-0.244c0.324-0.325,0.324-0.853,0-1.178L6.178,5z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./frontend/assets/icons/Lenspire_Icon_CloseButton.svg
// module id = 564
// module chunks = 0